import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Tooltip,
  useTheme,
  Grid,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventIcon from '@mui/icons-material/Event';
import BuildIcon from '@mui/icons-material/Build';
import CategoryIcon from '@mui/icons-material/Category';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommentIcon from '@mui/icons-material/Comment';
import { toast } from 'react-toastify';

// Format date to dd/mm/yyyy
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date)) return 'N/A';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Helper to fix invalid URLs like "http:/..." → "http://..."
const fixImageUrl = (url) => {
  if (!url) return null;
  return url.replace(/^http:\/([^/])/, 'http://$1');
};

// const InfoRow = ({ icon, label, value, isFirst = false }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: 1.5,
//       mb: 1.2,
//       mt: isFirst ? 1.8 : 0,
//     }}
//   >
//     {icon}
//     <Typography
//       variant="body1"
//       sx={{
//         fontWeight: 700,
//         minWidth: { xs: 100, sm: 120 },
//         fontSize: { xs: '0.9rem', sm: '1rem' },
//         flexShrink: 0,
//       }}
//     >
//       {label}:
//     </Typography>
//     <Typography
//       variant="body1"
//       sx={{
//         fontSize: { xs: '0.9rem', sm: '1rem' },
//         flex: 1,
//         wordBreak: 'break-word',
//       }}
//     >
//       {value || 'N/A'}
//     </Typography>
//   </Box>
// );
// Reusable Label-Value Row (same as TaskStDialog)
const LabelValue = ({ label, value }) => (
  <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
    <Typography
      fontWeight="bold"
      color="text.secondary"
      sx={{
        whiteSpace: 'nowrap',
        fontSize: { xs: '0.99rem', sm: '1rem' },
      }}
    >
      {label}:
    </Typography>
    <Typography sx={{ fontSize: { xs: '0.99rem', sm: '1rem' } }}>
      {value || 'N/A'}
    </Typography>
  </Box>
);

// Format time to 12-hour with AM/PM
const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};
const TaskAcceptDialog = ({ open, onClose, ticket, onSubmit, getStatusChip }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [acceptance, setAcceptance] = useState('');
  const [remark, setRemark] = useState('');
  const [zoomOpen, setZoomOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setAcceptance('');
      setRemark('');
    }
  }, [open, ticket]);

  if (!ticket || !open) return null;

  const imageUrl = fixImageUrl(ticket.ImgName);
  const hasImage = !!imageUrl;

  const handleSubmit = () => {
    if (!acceptance) {
      toast.warning('Please select acceptance');
      return;
    }
    if (acceptance === 'no' && !remark) {
      toast.warning('Please provide a remark for rejection.');
      return;
    }
    onSubmit(ticket.TicketId, acceptance, remark);
    onClose();
  };

  const handleCancel = () => {
    setAcceptance('');
    setRemark('');
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: 6,
            width: { xs: '95%', sm: '75%', md: '65%' },
            maxWidth: { xs: '95%', sm: 450, md: 550 },
            m: { xs: 1, sm: 2 },
          },
        }}
      >
        {/* Gradient Header */}
        <DialogTitle
          sx={{
            pt: 1.5,
            pb: 1.5,
            px: 3,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 'bold',
            background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            color: '#fff',
            position: 'relative',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '1.1rem', sm: '1.4rem' },
              color: '#fff',
            }}
          >
            Task Acceptance
          </Typography>

          <Box sx={{ ml: 2 }}>
            {getStatusChip(ticket.TicketSt)}
          </Box>
        </DialogTitle>

        {/* Content */}
        {/* <DialogContent sx={{ px: { xs: 2.5, sm: 3.5 } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <InfoRow
                  icon={<AssignmentIcon color="primary" fontSize="small" />}
                  label="Ticket No."
                  value={ticket.TicketNo}
                  isFirst={true}
                />
                <InfoRow
                  icon={<PersonIcon color="primary" fontSize="small" />}
                  label="RaisedBy."
                  value={ticket.Name}
                />
                <InfoRow
                  icon={<EventIcon color="primary" fontSize="small" />}
                  label="Date"
                  value={formatDate(ticket.TktDate)}
                />
                <InfoRow
                  icon={<BuildIcon color="primary" fontSize="small" />}
                  label="Service Name"
                  value={ticket.ServiceName}
                />
                <InfoRow
                  icon={<CategoryIcon color="primary" fontSize="small" />}
                  label="Category"
                  value={ticket.CategoryName}
                />
                <InfoRow
                  icon={<SubdirectoryArrowRightIcon color="primary" fontSize="small" />}
                  label="SubCategory"
                  value={ticket.SubCategoryName}
                />
                <InfoRow
                  icon={<PersonIcon color="primary" fontSize="small" />}
                  label="Service Provider"
                  value={ticket.ServiceProvider}
                />

        
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0, mb: 0 }}>
                  <CheckCircleIcon color="primary" fontSize="small" />
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 700,
                      minWidth: { xs: 100, sm: 120 },
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                      flexShrink: 0,
                    }}
                  >
                    Acceptance:
                  </Typography>

                  <RadioGroup
                    row
                    value={acceptance}
                    onChange={(e) => setAcceptance(e.target.value)}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'nowrap',
                      gap: { xs: 1.5, sm: 2 },
                      overflowX: 'auto',
                      '& .MuiFormControlLabel-root': {
                        marginRight: 0,
                        paddingRight: 0,
                      },
                    }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio size="small" />}
                      label={
                        <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
                          Accept
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label={
                        <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
                          Reject
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>

    
                {acceptance === 'no' && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mt: 1.5 }}>
                    <CommentIcon color="primary" fontSize="small" sx={{ mt: 1 }} />
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: { xs: 1, sm: 1, md: 2 }, flex: 1 }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 700,
                          mb: 0.5,
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                        }}
                      >
                        Remark:
                      </Typography>
                      <TextField
                        size="small"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter reason for rejection"
                        fullWidth
                        multiline
                        rows={1}
                        sx={{
                          '& .MuiInputBase-input': {
                            fontSize: { xs: '0.9rem', sm: '0.95rem' },
                          },
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>    
            <Grid item xs={12} sm={4} sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box
                sx={{
                  width: { xs: 100, sm: 120 },
                  height: { xs: 100, sm: 120 },
                  borderRadius: 2,
                  overflow: 'hidden',
                  position: 'relative',
                  bgcolor: hasImage ? 'transparent' : 'grey.50',
                  border: hasImage
                    ? `2px solid ${theme.palette.primary.main}`
                    : `2px dashed ${theme.palette.grey[400]}`,
                  boxShadow: hasImage ? 2 : 1,
                  cursor: hasImage ? 'pointer' : 'default',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: 'auto',
                }}
                onClick={() => hasImage && setZoomOpen(true)}
              >
                {hasImage ? (
                  <Box
                    component="img"
                    src={imageUrl}
                    alt="Ticket"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: '0.7rem', fontWeight: 500 }}
                  >
                    No Image
                  </Typography>
                )}
              </Box>

              <Typography
                variant="caption"
                display="block"
                mt={1}
                color="text.secondary"
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                {hasImage ? 'Click to Zoom' : ''}
              </Typography>
            </Grid>

          </Grid>

        </DialogContent> */}

{/* Content */}
<DialogContent sx={{ px: { xs: 2.5, sm: 3.5 } }}>
  {/* TOP ROW: Fields + Image */}
  <Box sx={{ display: 'flex', flexDirection: 'row', gap: { xs: 0, sm: 1, md: 1 }, alignItems: 'flex-start', mb: { xs: 0, sm: -3, md: -3 } }}>
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
      <Box mb={1} mt={1}><LabelValue label="Ticket No" value={ticket.TicketNo} /></Box>
      <Box mb={1}><LabelValue label="RaisedBy" value={ticket.Name} /></Box>
      <Box mb={1} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row', md: 'row' }, gap: { xs: 1, sm: 0, md: 0 } }}>
        <LabelValue label="Date" value={formatDate(ticket.TktDate)} />
        <Box sx={{ display: { xs: 'none', sm: 'block' }, mx: 1 }}>|</Box>
        <LabelValue label="Time" value={formatTime(ticket.TktDate)} />
      </Box>
    </Box>

    {/* Image Box – Same as TaskStDialog */}
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'flex-start', minWidth: { xs: 120, sm: 150 }, mt: '10px'
    }}>
      <Box
        sx={{
          width: { xs: 100, sm: 90 },
          height: { xs: 100, sm: 90 },
          borderRadius: 2,
          border: hasImage ? `2px solid ${theme.palette.primary.main}` : `2px dashed ${theme.palette.grey[400]}`,
          overflow: 'hidden',
          position: 'relative',
          bgcolor: hasImage ? 'transparent' : 'grey.50',
          boxShadow: hasImage ? 3 : 1,
          cursor: hasImage ? 'pointer' : 'default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => hasImage && setZoomOpen(true)}
      >
        {hasImage ? (
          <Box
            component="img"
            src={imageUrl}
            alt="Ticket"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              fontWeight: 500,
              textAlign: 'center',
            }}
          >
            No Image
          </Typography>
        )}
      </Box>

      <Typography
        variant="caption"
        display="block"
        mt={0.5}
        color="text.secondary"
        sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
      >
        {hasImage ? 'Click to Zoom' : ''}
      </Typography>
    </Box>
  </Box>

  {/* Remaining Fields */}
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ mt: { xs: 0, sm: 3, md: 3 } }}>
      <LabelValue label="Service Name" value={ticket.ServiceName} />
    </Box>
    <Box mb={1} sx={{ mt: { xs: 0, sm: 0, md: 1.5 } }}>
      <LabelValue label="Category" value={ticket.CategoryName} />
    </Box>
    <Box mb={1}><LabelValue label="SubCategory" value={ticket.SubCategoryName} /></Box>
    <Box mb={1}><LabelValue label="Service Provider" value={ticket.ServiceProvider} /></Box>

    {/* Acceptance Radio */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
      <Typography fontWeight="bold" color="text.secondary" sx={{ whiteSpace: 'nowrap', fontSize: { xs: '0.99rem', sm: '1rem' } }}>
        Acceptance:
      </Typography>

      <RadioGroup
        row
        value={acceptance}
        onChange={(e) => setAcceptance(e.target.value)}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          gap: { xs: 1.5, sm: 2 },
          overflowX: 'auto',
          '& .MuiFormControlLabel-root': { marginRight: 0 },
        }}
      >
        <FormControlLabel
          value="yes"
          control={<Radio size="small" />}
          label={
            <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
              Accept
            </Typography>
          }
        />
        <FormControlLabel
          value="no"
          control={<Radio size="small" />}
          label={
            <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
              Reject
            </Typography>
          }
        />
      </RadioGroup>
    </Box>

    {/* Remark Field */}
    {acceptance === 'no' && (
      <Box sx={{ mt: 1.5 }}>
        <Typography
          fontWeight="bold"
          color="text.secondary"
          sx={{ mb: 0.5, fontSize: { xs: '0.99rem', sm: '1rem' } }}
        >
          Remark:
        </Typography>
        <TextField
          size="small"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter reason for rejection"
          fullWidth
          multiline
          rows={2}
          sx={{
            '& .MuiInputBase-root': {
              fontSize: { xs: '0.9rem', sm: '0.95rem' },
              '& .MuiInputBase-input': { overflowY: 'auto', maxHeight: 120 },
            },
          }}
        />
      </Box>
    )}
  </Box>
</DialogContent>
        {/* Action Buttons */}
        <DialogActions sx={{ px: 3, pb: 1, mt: -2, justifyContent: 'flex-end', gap: 1.3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!acceptance || (acceptance === 'no' && !remark)}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'bold',
              px: 2,
              fontSize: { xs: '0.99rem', sm: '1rem' },
              minWidth: 110,
            }}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={handleCancel}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 'bold',
              px: 2,
              fontSize: { xs: '0.99rem', sm: '1rem' },
              minWidth: 110,
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Zoom Dialog */}
      {/* <Dialog
        open={zoomOpen}
        onClose={() => setZoomOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { backgroundColor: 'transparent', boxShadow: 'none' },
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Zoomed Ticket"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/600x400?text=Image+Not+Found';
          }}
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: '80vh',
            objectFit: 'contain',
            borderRadius: 2,
            boxShadow: 3,
          }}
        />
      </Dialog> */}

      {/* Zoom Dialog – FIXED */}
      <Dialog
        open={zoomOpen}
        onClose={() => setZoomOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { backgroundColor: 'transparent', boxShadow: 'none', m: 2 },
        }}
        BackdropProps={{ sx: { backgroundColor: 'rgba(0,0,0,0.95)' } }}
      >
        <IconButton
          onClick={() => setZoomOpen(false)}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'rgba(255,255,255,0.9)',
            color: 'black',
            '&:hover': { bgcolor: 'white' },
            zIndex: 10,
            boxShadow: 3,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '90vh',
            cursor: 'zoom-out',
          }}
          onClick={() => setZoomOpen(false)}
        >
          {hasImage ? (
            <Box
              component="img"
              src={imageUrl}
              alt="Zoomed Ticket"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
              sx={{
                maxWidth: '90%',
                maxHeight: '90%',
                objectFit: 'contain',
                borderRadius: 2,
                boxShadow: 10,
                userSelect: 'none',
              }}
            />
          ) : null}
        </Box>
      </Dialog>
    </>
  );
};

export default TaskAcceptDialog;















// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   IconButton,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   TextField,
//   Tooltip,
//   useTheme,
//   Grid,
//   useMediaQuery,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import EventIcon from '@mui/icons-material/Event';
// import BuildIcon from '@mui/icons-material/Build';
// import CategoryIcon from '@mui/icons-material/Category';
// import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
// import PersonIcon from '@mui/icons-material/Person';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CommentIcon from '@mui/icons-material/Comment';
// import { toast } from 'react-toastify';

// // Format date to dd/mm/yyyy
// const formatDate = (dateString) => {
//   if (!dateString) return 'N/A';
//   const date = new Date(dateString);
//   if (isNaN(date)) return 'N/A';
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}/${month}/${year}`;
// };

// // Helper to fix invalid URLs like "http:/..." → "http://..."
// const fixImageUrl = (url) => {
//   if (!url) return null;
//   return url.replace(/^http:\/([^/])/, 'http://$1');
// };

// const InfoRow = ({ icon, label, value, isFirst = false }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       alignItems: 'center',
//       gap: 1.5,
//       mb: 1.2,
//       mt: isFirst ? 1.8 : 0,
//     }}
//   >
//     {icon}
//     <Typography
//       variant="body1"
//       sx={{
//         fontWeight: 700,
//         minWidth: { xs: 100, sm: 120 },
//         fontSize: { xs: '0.9rem', sm: '1rem' },
//         flexShrink: 0,
//       }}
//     >
//       {label}:
//     </Typography>
//     <Typography
//       variant="body1"
//       sx={{
//         fontSize: { xs: '0.9rem', sm: '1rem' },
//         flex: 1,
//         wordBreak: 'break-word',
//       }}
//     >
//       {value || 'N/A'}
//     </Typography>
//   </Box>
// );

// const TaskAcceptDialog = ({ open, onClose, ticket, onSubmit, getStatusChip }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [acceptance, setAcceptance] = useState('');
//   const [remark, setRemark] = useState('');
//   const [zoomOpen, setZoomOpen] = useState(false);

//   useEffect(() => {
//     if (open) {
//       setAcceptance('');
//       setRemark('');
//     }
//   }, [open, ticket]);

//   if (!ticket || !open) return null;

//   const imageUrl = fixImageUrl(ticket.ImgName);
//   const hasImage = !!imageUrl;

//   const handleSubmit = () => {
//     if (!acceptance) {
//       toast.warning('Please select acceptance');
//       return;
//     }
//     if (acceptance === 'no' && !remark) {
//       toast.warning('Please provide a remark for rejection.');
//       return;
//     }
//     onSubmit(ticket.TicketId, acceptance, remark);
//     onClose();
//   };

//   const handleCancel = () => {
//     setAcceptance('');
//     setRemark('');
//     onClose();
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleCancel}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 4,
//             overflow: 'hidden',
//             boxShadow: 6,
//             width: { xs: '95%', sm: '75%', md: '65%' },
//             maxWidth: { xs: '95%', sm: 450, md: 550 },
//             m: { xs: 1, sm: 2 },
//           },
//         }}
//       >
//         {/* Gradient Header */}
//         <DialogTitle
//           sx={{
//             pt: 1.5,
//             pb: 1.5,
//             px: 3,
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             fontWeight: 'bold',
//             background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//             color: '#fff',
//             position: 'relative',
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 'bold',
//               fontSize: { xs: '1.1rem', sm: '1.4rem' },
//               color: '#fff',
//             }}
//           >
//             Task Acceptance
//           </Typography>

//           <Box sx={{ ml: 2 }}>
//             {getStatusChip(ticket.TicketSt)}
//           </Box>
//         </DialogTitle>

//         {/* Content */}
//         <DialogContent sx={{ px: { xs: 2.5, sm: 3.5 } }}>
//           <Grid container spacing={2}>
//             {/* Left: Info */}
//             <Grid item xs={12} sm={8}>
//               <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                 <InfoRow
//                   icon={<AssignmentIcon color="primary" fontSize="small" />}
//                   label="Ticket No."
//                   value={ticket.TicketNo}
//                   isFirst={true}
//                 />
//                 <InfoRow
//                   icon={<PersonIcon color="primary" fontSize="small" />}
//                   label="RaisedBy."
//                   value={ticket.Name}
//                 />
//                 <InfoRow
//                   icon={<EventIcon color="primary" fontSize="small" />}
//                   label="Date"
//                   value={formatDate(ticket.TktDate)}
//                 />
//                 <InfoRow
//                   icon={<BuildIcon color="primary" fontSize="small" />}
//                   label="Service Name"
//                   value={ticket.ServiceName}
//                 />
//                 <InfoRow
//                   icon={<CategoryIcon color="primary" fontSize="small" />}
//                   label="Category"
//                   value={ticket.CategoryName}
//                 />
//                 <InfoRow
//                   icon={<SubdirectoryArrowRightIcon color="primary" fontSize="small" />}
//                   label="SubCategory"
//                   value={ticket.SubCategoryName}
//                 />
//                 <InfoRow
//                   icon={<PersonIcon color="primary" fontSize="small" />}
//                   label="Service Provider"
//                   value={ticket.ServiceProvider}
//                 />

//                 {/* Acceptance Radio */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0, mb: 0 }}>
//                   <CheckCircleIcon color="primary" fontSize="small" />
//                   <Typography
//                     variant="body1"
//                     sx={{
//                       fontWeight: 700,
//                       minWidth: { xs: 100, sm: 120 },
//                       fontSize: { xs: '0.9rem', sm: '1rem' },
//                       flexShrink: 0,
//                     }}
//                   >
//                     Acceptance:
//                   </Typography>

//                   <RadioGroup
//                     row
//                     value={acceptance}
//                     onChange={(e) => setAcceptance(e.target.value)}
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'row',
//                       flexWrap: 'nowrap',
//                       gap: { xs: 1.5, sm: 2 },
//                       overflowX: 'auto',
//                       '& .MuiFormControlLabel-root': {
//                         marginRight: 0,
//                         paddingRight: 0,
//                       },
//                     }}
//                   >
//                     <FormControlLabel
//                       value="yes"
//                       control={<Radio size="small" />}
//                       label={
//                         <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
//                           Accept
//                         </Typography>
//                       }
//                     />
//                     <FormControlLabel
//                       value="no"
//                       control={<Radio size="small" />}
//                       label={
//                         <Typography sx={{ fontSize: { xs: '0.88rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
//                           Reject
//                         </Typography>
//                       }
//                     />
//                   </RadioGroup>
//                 </Box>

//                 {/* Remark Field */}
//                 {acceptance === 'no' && (
//                   <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mt: 1.5 }}>
//                     <CommentIcon color="primary" fontSize="small" sx={{ mt: 1 }} />
//                     <Box sx={{ display: 'flex', flexDirection: 'row', gap: { xs: 1, sm: 1, md: 2 }, flex: 1 }}>
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           fontWeight: 700,
//                           mb: 0.5,
//                           fontSize: { xs: '0.9rem', sm: '1rem' },
//                         }}
//                       >
//                         Remark:
//                       </Typography>
//                       <TextField
//                         size="small"
//                         value={remark}
//                         onChange={(e) => setRemark(e.target.value)}
//                         placeholder="Enter reason for rejection"
//                         fullWidth
//                         multiline
//                         rows={1}
//                         sx={{
//                           '& .MuiInputBase-input': {
//                             fontSize: { xs: '0.9rem', sm: '0.95rem' },
//                           },
//                         }}
//                       />
//                     </Box>
//                   </Box>
//                 )}
//               </Box>
//             </Grid>

//             {/* Right: Image */}
//             {/* <Grid item xs={12} sm={4} sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//               <Box
//                 component="img"
//                 src={hasImage ? imageUrl : 'https://via.placeholder.com/120?text=No+Image'}
//                 alt="Ticket"
//                 onError={(e) => {
//                   e.target.src = 'https://via.placeholder.com/120?text=No+Image';
//                 }}
//                 onClick={() => hasImage && setZoomOpen(true)}
//                 sx={{
//                   width: { xs: 100, sm: 120 },
//                   height: { xs: 100, sm: 120 },
//                   borderRadius: 2,
//                   objectFit: 'cover',
//                   cursor: hasImage ? 'pointer' : 'default',
//                   border: `2px ${hasImage ? 'solid' : 'dashed'} ${hasImage ? theme.palette.primary.main : theme.palette.grey[400]}`,
//                   boxShadow: hasImage ? 2 : 1,
//                   mx: 'auto',
//                   opacity: hasImage ? 1 : 0.6,
//                 }}
//               />
//               <Typography
//                 variant="caption"
//                 display="block"
//                 mt={1}
//                 color="text.secondary"
//                 sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
//               >
//                 {hasImage ? 'Click to Zoom' : 'No Image Available'}
//               </Typography>
//             </Grid> */}
//             {/* Right: Image – FIXED */}
//             <Grid item xs={12} sm={4} sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//               <Box
//                 sx={{
//                   width: { xs: 100, sm: 120 },
//                   height: { xs: 100, sm: 120 },
//                   borderRadius: 2,
//                   overflow: 'hidden',
//                   position: 'relative',
//                   bgcolor: hasImage ? 'transparent' : 'grey.50',
//                   border: hasImage
//                     ? `2px solid ${theme.palette.primary.main}`
//                     : `2px dashed ${theme.palette.grey[400]}`,
//                   boxShadow: hasImage ? 2 : 1,
//                   cursor: hasImage ? 'pointer' : 'default',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   mx: 'auto',
//                 }}
//                 onClick={() => hasImage && setZoomOpen(true)}
//               >
//                 {hasImage ? (
//                   <Box
//                     component="img"
//                     src={imageUrl}
//                     alt="Ticket"
//                     onError={(e) => {
//                       e.target.style.display = 'none';
//                     }}
//                     sx={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                     }}
//                   />
//                 ) : (
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                     sx={{ fontSize: '0.7rem', fontWeight: 500 }}
//                   >
//                     No Image
//                   </Typography>
//                 )}
//               </Box>

//               <Typography
//                 variant="caption"
//                 display="block"
//                 mt={1}
//                 color="text.secondary"
//                 sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
//               >
//                 {hasImage ? 'Click to Zoom' : ''}
//               </Typography>
//             </Grid>

//           </Grid>

//         </DialogContent>

//         {/* Action Buttons */}
//         <DialogActions sx={{ px: 3, pb: 1, mt: -2, justifyContent: 'flex-end', gap: 1.3 }}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//             disabled={!acceptance || (acceptance === 'no' && !remark)}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               fontWeight: 'bold',
//               px: 2,
//               fontSize: { xs: '0.99rem', sm: '1rem' },
//               minWidth: 110,
//             }}
//           >
//             Submit
//           </Button>
//           <Button
//             variant="outlined"
//             color="error"
//             onClick={handleCancel}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               fontWeight: 'bold',
//               px: 2,
//               fontSize: { xs: '0.99rem', sm: '1rem' },
//               minWidth: 110,
//             }}
//           >
//             Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Zoom Dialog */}
//       {/* <Dialog
//         open={zoomOpen}
//         onClose={() => setZoomOpen(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: { backgroundColor: 'transparent', boxShadow: 'none' },
//         }}
//       >
//         <Box
//           component="img"
//           src={imageUrl}
//           alt="Zoomed Ticket"
//           onError={(e) => {
//             e.target.src = 'https://via.placeholder.com/600x400?text=Image+Not+Found';
//           }}
//           sx={{
//             width: '100%',
//             height: 'auto',
//             maxHeight: '80vh',
//             objectFit: 'contain',
//             borderRadius: 2,
//             boxShadow: 3,
//           }}
//         />
//       </Dialog> */}

//       {/* Zoom Dialog – FIXED */}
//       <Dialog
//         open={zoomOpen}
//         onClose={() => setZoomOpen(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: { backgroundColor: 'transparent', boxShadow: 'none', m: 2 },
//         }}
//         BackdropProps={{ sx: { backgroundColor: 'rgba(0,0,0,0.95)' } }}
//       >
//         <IconButton
//           onClick={() => setZoomOpen(false)}
//           sx={{
//             position: 'absolute',
//             top: 8,
//             right: 8,
//             bgcolor: 'rgba(255,255,255,0.9)',
//             color: 'black',
//             '&:hover': { bgcolor: 'white' },
//             zIndex: 10,
//             boxShadow: 3,
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             height: '90vh',
//             cursor: 'zoom-out',
//           }}
//           onClick={() => setZoomOpen(false)}
//         >
//           {hasImage ? (
//             <Box
//               component="img"
//               src={imageUrl}
//               alt="Zoomed Ticket"
//               onError={(e) => {
//                 e.target.style.display = 'none';
//               }}
//               sx={{
//                 maxWidth: '90%',
//                 maxHeight: '90%',
//                 objectFit: 'contain',
//                 borderRadius: 2,
//                 boxShadow: 10,
//                 userSelect: 'none',
//               }}
//             />
//           ) : null}
//         </Box>
//       </Dialog>
//     </>
//   );
// };

// export default TaskAcceptDialog;